import type { RefObject } from 'react'
import { useEffect, useState } from 'react'

import { useContainerSize } from './use-container-size'

interface UseComputedStyleConfig {
  htmlElement?: RefObject<HTMLElement | null>
  /** Will trigger a recalculation when any of the dependencies change. */
  dependencies?: React.DependencyList
}

/** Used to listen to changes in the computed style of a container element.
 * By default, it recalculates the computed style when the width of the container changes.
 * Adding dependencies will trigger a recalculation when any of the dependencies change.
 */
export function useComputedStyle({ htmlElement, dependencies = [] }: UseComputedStyleConfig) {
  const { containerWidth: width } = useContainerSize({ containerElement: htmlElement })
  const [computedStyle, setComputedStyle] = useState<CSSStyleDeclaration | null>(null)

  useEffect(() => {
    if (htmlElement?.current) {
      setComputedStyle(getComputedStyle(htmlElement.current))
    }
  }, [htmlElement, width, ...dependencies])

  return computedStyle
}
